export const STATUS = {
	En_Proceso: 1,
	Aprobada_RH: 2,
	Finalizada: 3,
	Rechazada: 4,
}
export const MINIMUM_PAYMENT_MX = 8782.31
export const MINIMUM_PAYMENT_GT = 3973.05
